/* assets/socks-pdp-bundle.js
 * Diabetic socks PDP add-on popup.
 *
 * Works with the regular product form and the EcomRise volume-discount flow without
 * taking ownership of the main add-to-cart request.
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-socks-pdp-bundle-root]';
  var patchedCart = false;
  var pendingCartOpen = null;
  var activeController = null;

  function parseConfig(root) {
    try {
      return JSON.parse(root.getAttribute('data-socks-pdp-bundle-config') || '{}');
    } catch (error) {
      console.warn('[socks-pdp-bundle] Invalid config', error);
      return {};
    }
  }

  function getOriginalCartHandler() {
    if (!window.theme || !window.theme.Cart || !window.theme.Cart.prototype) return null;
    return window.theme.Cart.prototype._socksPdpBundleOriginalOnProductAdded || window.theme.Cart.prototype._onProductAdded;
  }

  function openCart(controller) {
    if (controller && controller.config && controller.config.postAddAction === 'checkout') {
      window.location.href = '/checkout';
      return;
    }

    var original = getOriginalCartHandler();
    if (typeof original === 'function') {
      original();
      return;
    }

    window.location.href = window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';
  }

  function patchCartCallback() {
    if (patchedCart) return;
    if (!window.theme || !window.theme.Cart || !window.theme.Cart.prototype || typeof window.theme.Cart.prototype._onProductAdded !== 'function') {
      window.setTimeout(patchCartCallback, 50);
      return;
    }

    var proto = window.theme.Cart.prototype;
    if (proto._socksPdpBundlePatched) {
      patchedCart = true;
      return;
    }

    var original = proto._onProductAdded;
    proto._socksPdpBundleOriginalOnProductAdded = original;
    proto._onProductAdded = function () {
      if (pendingCartOpen && pendingCartOpen.controller && pendingCartOpen.controller.shouldOpenForPending(pendingCartOpen)) {
        var pending = pendingCartOpen;
        pendingCartOpen = null;
        pending.controller.openModal(function () {
          original();
        });
        return;
      }

      original();
    };
    proto._socksPdpBundlePatched = true;
    patchedCart = true;
  }

  function isAddToCartSubmit(event) {
    var submitter = event.submitter || document.activeElement;
    if (!submitter) return true;
    if (submitter.matches && submitter.matches('[data-add-to-cart], button[name="add"], input[name="add"]')) return true;
    if (submitter.closest && submitter.closest('[data-add-to-cart]')) return true;
    return false;
  }

  function getFormQuantity(form) {
    var quantity = 1;

    try {
      var data = new FormData(form);
      var formQuantity = data.get('quantity');
      if (formQuantity !== null && formQuantity !== '') {
        quantity = parseInt(formQuantity, 10);
      }
    } catch (error) {
      // Fall through to DOM lookup.
    }

    if (!quantity || isNaN(quantity)) {
      var quantityInput = form.querySelector('[name="quantity"]');
      if (quantityInput && quantityInput.value) {
        quantity = parseInt(quantityInput.value, 10);
      }
    }

    if (!quantity || isNaN(quantity) || quantity < 1) quantity = 1;
    return quantity;
  }

  function isSelectedPackMode(controller) {
    return controller && controller.config && controller.config.qualificationMode === 'selected_pack';
  }

  function normalizeHandle(handle) {
    return (handle || '').toString().trim();
  }

  function qualifiedHandles(config) {
    return (config.qualifiedPackHandles || []).map(normalizeHandle).filter(Boolean);
  }

  function isHandleQualified(config, handle) {
    return qualifiedHandles(config).indexOf(normalizeHandle(handle)) !== -1;
  }

  function effectiveMinQuantity(controller) {
    return isSelectedPackMode(controller) ? 1 : (parseInt(controller.config.minQuantity, 10) || 1);
  }

  function getSelectedAddonIds(controller) {
    return Array.prototype.slice.call(controller.root.querySelectorAll('[data-socks-pdp-bundle-addon-input]:checked'))
      .map(function (input) { return parseInt(input.value, 10); })
      .filter(function (id) { return id && !isNaN(id); });
  }

  function hasAddonAlready(cart, addonIds) {
    if (!cart || !cart.items || !addonIds.length) return false;
    return cart.items.some(function (item) {
      return addonIds.indexOf(parseInt(item.variant_id, 10)) !== -1;
    });
  }

  function haveAllAddonsAlready(cart, addonIds) {
    if (!cart || !cart.items || !addonIds.length) return false;
    return addonIds.every(function (id) {
      return hasAddonAlready(cart, [id]);
    });
  }

  function Controller(root) {
    this.root = root;
    this.config = parseConfig(root);
    this.form = root.closest('form') || document.querySelector('[data-product-form]');
    this.teaser = root.querySelector('[data-socks-pdp-bundle-teaser]');
    this.modal = root.querySelector('[data-socks-pdp-bundle-modal]');
    this.addButton = root.querySelector('[data-socks-pdp-bundle-add]');
    this.skipButton = root.querySelector('[data-socks-pdp-bundle-skip]');
    this.closeButton = root.querySelector('[data-socks-pdp-bundle-close]');
    this.error = root.querySelector('[data-socks-pdp-bundle-error]');
    this.lastFocus = null;
    this.isAdding = false;
    this.selectedPack = {
      packHandle: this.config.initialSelectedPackHandle || this.config.productHandle,
      productId: this.config.productId,
      variantId: this.config.initialSelectedVariantId,
      qualifiesForBundle: isHandleQualified(this.config, this.config.initialSelectedPackHandle || this.config.productHandle)
    };
    this.bindEvents();
    this.updateTeaser();
  }

  Controller.prototype.bindEvents = function () {
    var self = this;

    if (this.form) {
      this.form.addEventListener('submit', function (event) {
        if (!self.config.enabled || !isAddToCartSubmit(event)) return;
        var quantity = getFormQuantity(self.form);
        var minQuantity = effectiveMinQuantity(self);
        var qualifies = isSelectedPackMode(self) ? !!(self.selectedPack && self.selectedPack.qualifiesForBundle) : quantity >= minQuantity;
        if (qualifies && quantity >= minQuantity) {
          pendingCartOpen = {
            controller: self,
            quantity: quantity,
            packHandle: self.selectedPack && self.selectedPack.packHandle,
            productId: self.selectedPack && self.selectedPack.productId,
            variantId: self.selectedPack && self.selectedPack.variantId,
            qualifiesForBundle: !!(self.selectedPack && self.selectedPack.qualifiesForBundle),
            expiresAt: Date.now() + 10000
          };
        } else {
          pendingCartOpen = null;
        }
      }, true);

      this.form.addEventListener('change', function () {
        self.updateTeaser();
      });

      this.form.addEventListener('socks:pdp-pack-change', function (event) {
        var detail = event.detail || {};
        self.selectedPack = {
          packHandle: detail.packHandle,
          productId: detail.productId,
          variantId: detail.variantId,
          qualifiesForBundle: !!detail.qualifiesForBundle
        };
        self.updateTeaser();
      });
    }

    document.addEventListener('ER_PIXEL_CART_ADDED', function (event) {
      var detail = event.detail || {};
      var quantity = parseInt(detail.quantity, 10) || 1;
      var productId = parseInt(detail.productId, 10);
      var variantId = parseInt(detail.variantId || detail.variant_id || detail.id, 10);
      var minQuantity = effectiveMinQuantity(self);

      if (!self.config.enabled || quantity < minQuantity) return;
      if (isSelectedPackMode(self)) {
        if (!self.selectedPack || !self.selectedPack.qualifiesForBundle) return;
        if (productId) {
          if (productId !== parseInt(self.selectedPack.productId, 10)) return;
        } else if (variantId) {
          if (variantId !== parseInt(self.selectedPack.variantId, 10)) return;
        } else {
          return;
        }
      } else if (productId !== parseInt(self.config.productId, 10)) {
        return;
      }
      pendingCartOpen = null;
      self.openModal(function () {
        openCart(self);
      });
    });

    if (this.addButton) {
      this.addButton.addEventListener('click', function () {
        self.addSelectedAddons();
      });
    }

    if (this.skipButton) {
      this.skipButton.addEventListener('click', function () {
        self.closeModal();
        openCart(self);
      });
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', function () {
        self.closeModal();
        openCart(self);
      });
    }

    if (this.modal) {
      this.modal.addEventListener('click', function (event) {
        if (event.target === self.modal) {
          self.closeModal();
          openCart(self);
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.modal && !self.modal.hasAttribute('hidden')) {
        self.closeModal();
        openCart(self);
      }
    });
  };

  Controller.prototype.updateTeaser = function () {
    if (!this.teaser || !this.form) return;
    var quantity = getFormQuantity(this.form);
    var minQuantity = effectiveMinQuantity(this);
    if (isSelectedPackMode(this)) {
      this.teaser.hidden = !this.selectedPack || !this.selectedPack.qualifiesForBundle || quantity < minQuantity;
      return;
    }
    this.teaser.hidden = quantity < minQuantity;
  };

  Controller.prototype.shouldOpenForPending = function (pending) {
    if (!pending || pending.controller !== this) return false;
    if (pending.expiresAt && Date.now() > pending.expiresAt) return false;
    var minQuantity = effectiveMinQuantity(this);
    if (isSelectedPackMode(this)) {
      return !!pending.qualifiesForBundle && pending.quantity >= minQuantity;
    }
    return pending.quantity >= minQuantity;
  };

  Controller.prototype.openModal = function (afterClose) {
    var self = this;
    if (!this.modal || activeController) return;
    activeController = this;

    var addonIds = (this.config.addOns || []).map(function (addon) { return parseInt(addon.variantId, 10); }).filter(Boolean);

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (haveAllAddonsAlready(cart, addonIds)) {
          activeController = null;
          if (typeof afterClose === 'function') afterClose();
          return;
        }

        self.afterClose = afterClose;
        self.lastFocus = document.activeElement;
        self.hideError();
        self.modal.removeAttribute('hidden');
        document.body.classList.add('socks-pdp-bundle-open');

        var focusTarget = self.modal.querySelector('[data-socks-pdp-bundle-add]') || self.modal.querySelector('button, input, a');
        if (focusTarget) focusTarget.focus();
      })
      .catch(function () {
        activeController = null;
        if (typeof afterClose === 'function') afterClose();
      });
  };

  Controller.prototype.closeModal = function () {
    if (!this.modal) return;
    this.modal.setAttribute('hidden', 'hidden');
    document.body.classList.remove('socks-pdp-bundle-open');
    activeController = null;
    if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
      this.lastFocus.focus();
    }
  };

  Controller.prototype.hideError = function () {
    if (!this.error) return;
    this.error.hidden = true;
  };

  Controller.prototype.showError = function (message) {
    if (!this.error) return;
    this.error.textContent = message || this.config.errorText || 'The add-on could not be added.';
    this.error.hidden = false;
  };

  Controller.prototype.setAdding = function (isAdding) {
    this.isAdding = isAdding;
    if (!this.addButton) return;
    this.addButton.disabled = isAdding;
    var label = this.addButton.querySelector('[data-socks-pdp-bundle-add-label]');
    if (label) {
      label.textContent = isAdding ? this.config.addingLabel : this.config.addButtonLabel;
    }
  };

  Controller.prototype.addSelectedAddons = function () {
    var self = this;
    if (this.isAdding) return;

    var variantIds = getSelectedAddonIds(this);
    if (!variantIds.length) {
      this.closeModal();
      openCart(this);
      return;
    }

    this.setAdding(true);
    this.hideError();

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var items = variantIds
          .filter(function (id) { return !hasAddonAlready(cart, [id]); })
          .map(function (id) { return { id: id, quantity: 1 }; });

        if (!items.length) return null;

        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        }).then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok || json.status === 422) {
              throw new Error(json.description || json.message || self.config.errorText);
            }
            return json;
          });
        });
      })
      .then(function () {
        self.closeModal();
        openCart(self);
      })
      .catch(function (error) {
        self.showError(error && error.message ? error.message : self.config.errorText);
      })
      .finally(function () {
        self.setAdding(false);
      });
  };

  function init() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    if (!roots.length) return;

    patchCartCallback();

    roots.forEach(function (root) {
      if (root.__socksPdpBundle) return;
      root.__socksPdpBundle = new Controller(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
